var ɵ0 = { localeTag: 'health-check' };
var HealthCheckRoutingModule = /** @class */ (function () {
    function HealthCheckRoutingModule() {
    }
    return HealthCheckRoutingModule;
}());
export { HealthCheckRoutingModule };
export { ɵ0 };
